// SSR-only helpers shared by cards, listings and the article view.
import { getURL } from '@reperio-news/core.components/includes/Media';
import { formatRo } from '@reperio-news/core.components/dates.js';

/** Section label + link for a content item (category), or null. */
export function kicker(content) {
	const c = content?.category;
	if (!c?.name) return null;
	return { name: c.name, href: c.slug ? `/${c.slug}` : null };
}

/** "Ioana Marinescu" -> "IM" */
export function initials(name) {
	return String(name || '')
		.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map((w) => w[0].toUpperCase())
		.join('');
}

/** Resized avatar url through the media resizer, or null when the author has no avatar. */
export function avatarUrl(author, px = 48) {
	const u = author?.avatar?.url;
	if (!u) return null;
	return getURL(u, { p: `w=${px}&h=${px}&f=webp&r=cover` });
}

/** Romanian date label, lowercase month names (core dates.js). */
export function dateLabel(iso, pattern = 'D MMMM YYYY') {
	if (!iso) return '';
	try {
		return formatRo(iso, pattern);
	} catch (_e) {
		return '';
	}
}

export function stripHtml(html) {
	return String(html || '').replace(/<[^>]*>/g, ' ');
}

/** Reading time in minutes from editor.js blocks (paragraph/header/list/quote), ~200 wpm. */
export function readingMinutes(blocks) {
	let words = 0;
	for (const b of blocks || []) {
		const d = b?.data || {};
		let text = '';
		if (typeof d.text === 'string') text = d.text;
		else if (Array.isArray(d.items)) text = d.items.map((i) => (typeof i === 'string' ? i : i?.content || '')).join(' ');
		if (text) words += stripHtml(text).split(/\s+/).filter(Boolean).length;
	}
	return Math.max(1, Math.round(words / 200));
}

/** Author role for this domain (per-domain custom field), or null. */
export function authorRole(author, domain) {
	return author?.custom_fields?.[domain]?.profession || null;
}
